<template>
  <div
    v-if="show"
  >
    <CollapseTransition>
      <!-- 多包裹 -->
      <div
        v-if="parcelList.length > 1"
        class="transition-wrap"
      >
        <div class="font-c111 mt-20">
          {{TLang('该订单拆成','list')}} {{ parcelList.length }} {{TLang('个包裹发出','list')}}
        </div>
        <div class="line-dashed"></div>
        <div
          v-for="(parcelItem, index) in parcelList"
          :key="index"
        >
          <div
            v-if="index < 3"
            class="font-c666 mt-16"
          >
            {{TLang('包裹','list')}}{{ index + 1 }}：【{{ parcelItem.deliveryStatusName }}】{{ parcelItem.expressCompany }}：{{ parcelItem.expressOrderNo }}
          </div>
        </div>
        <div
          class="font-blue text-right mt-8"
          @click="
            () => {
              $router.push(`/order/logistics/list/${parcelList[0].deliveryOrderNo}`);
            }
          "
        >
          {{TLang('查看全部','list')}}
        </div>
      </div>
      <div
        v-for="(parcelItem, index) in parcelList"
        v-else
        :key="index"
        class="transition-wrap"
      >
        <!-- 中通快递：2484037545798547695 没有具体快递公司字段，暂取 deliveryWayName -->
        <div class="font-c111 mt-20">
          {{ parcelItem.expressCompany }}：{{ parcelItem.expressOrderNo }}
        </div>
        <div class="line-dashed"></div>
        <div class="single-parcel">
          <div
            v-for="(traceItem, traceIndex) in parcelItem.traces"
            :key="traceIndex"
          >
            <div
              v-if="traceIndex < 3"
              :class="!traceIndex ? '' : 'font-cccc mt-16'"
            >
              <div>
                <span :class="traceIndex > 0 ? 'font-cccc' : 'font-blue'">●&nbsp;</span>{{ traceItem.deliveryStatusName }} {{ traceItem.content }}
              </div>
            </div>
          </div>
          <div class="font-cccc mt-16">
            <span><span class="font-cccc">●&nbsp;</span>{{TLang('以上为最新跟踪信息','list')}}</span>&nbsp;&nbsp;<span
              class="font-blue text-right mr-8"
              @click="
                () => {
                  $router.push(`/order/logistics/list/${parcelItem.deliveryOrderNo}`);
                }
              "
            >{{TLang('查看全部','list')}}</span>
          </div>
        </div>
      </div>
    </CollapseTransition>
  </div>
</template>

<script>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
export default {
  components: {
    CollapseTransition,
  },
  props: {
    parcelList: Array,
    show: Boolean,
  },
  data: () => ({
    parcel: false,
  }),
};
</script>

<style lang="less" scoped>
.transition-wrap {
  width: 334px;
  height: 214px;
  padding: 0 24px;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 1000;

  position: absolute;
  top: 32px;
  left: 24px;
  overflow-y: scroll;
  &::before {
    content: "";

    position: absolute;
    top: -16px;
    left: 20px;

    border: solid 8px;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: #fff;
  }

  .line-dashed {
    border: dashed 1px #e5e5e5;
    margin: 10px 0;
  }
}
</style>
